import { render, staticRenderFns } from "./AgendaPage.vue?vue&type=template&id=ee3fceae&scoped=true"
import script from "./AgendaPage.vue?vue&type=script&lang=js"
export * from "./AgendaPage.vue?vue&type=script&lang=js"
import style0 from "./AgendaPage.vue?vue&type=style&index=0&id=ee3fceae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee3fceae",
  null
  
)

export default component.exports